import { useState, useCallback } from "react"
import { fetchTags, createTag, updateTag, deleteTag, addTagging, removeTagging } from "../api/tagsApi"

export function useTags() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetch = useCallback(async (filters = {}) => {
    setLoading(true)
    setError(null)
    try {
      setData(await fetchTags(filters))
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  return { data, loading, error, fetch }
}

function useMutation(fn) {
  const [status, setStatus] = useState("idle")

  const mutate = useCallback(async (...args) => {
    setStatus("pending")
    try {
      const result = await fn(...args)
      setStatus("success")
      return result
    } catch (err) {
      setStatus("error")
      throw err.response?.data?.errors || [err.message || "Something went wrong"]
    }
  }, [])

  return { mutate, isPending: status === "pending" }
}

export const useCreateTag = () => useMutation(createTag)
export const useUpdateTag = () => useMutation((id, payload) => updateTag(id, payload))
export const useDeleteTag = () => useMutation(deleteTag)
export const useAddTagging = () => useMutation(addTagging)
export const useRemoveTagging = () => useMutation(removeTagging)
